import React from 'react';
import styled from 'styled-components';
import { InAppFontList } from '../../../platform/assets/InAppFontList';
import { PickerItem } from '../../../ui/PickerMenu';
import { PickerMenuWithFilter } from '../../../ui/PickerMenuWithFilter';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { PopoutWidget } from '../workspace/widgets/WidgetInterface';

const FontLabel = styled.span<{ font: string }>`
    font-family: ${p => p.font};
`;

const pickerItems = InAppFontList.map(x => ({
    id: x.name,
    label: x.label,
}));

const renderItem = ({ id: fontName }: PickerItem) => {
    return <FontLabel font={fontName}>{fontName}</FontLabel>;
};

export const FontFamilyWidget = ({ widget }: { widget: PopoutWidget }) => {

    const onSelect = ({ id }: { id: string }) => {
        widget.update({
            open: false,
            value: id,
        });
    };

    return <Flexer flex width="18" height="20" padding=".5">
        <PickerMenuWithFilter allowKeyboard items={pickerItems} renderItem={renderItem} onAction={onSelect} />
    </Flexer>;
};
